import { Injectable } from '@angular/core';
import { BaseModalService } from 'src/app/shared/services/base-modal/base-modal.service';
import { UserPackageChangeConfiguration } from './user-package-change-configuration';

@Injectable({
  providedIn: 'root'
})
export class UserPackageChangeModalService extends BaseModalService<UserPackageChangeConfiguration> {}
